<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="form-base__title step-name">Сведения о заявителе</div>
        <div>
          <Subject
            :statement="statement"
            :subject="statement.subjects.applicant"
          />
        </div>
      </v-col>
    </v-row>
    <v-row v-if="statement.storageIssueStep2">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Идентификатор хранилища электронного документа (пакета электронных
          документов), переданного на хранение и указанный в свидетельстве
        </div>
        <Step2 :data="statement.storageIssueStep2"></Step2>
      </v-col>
    </v-row>
    <v-row v-if="statement.storageIssueStep3">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Реквизиты счета для возврата заявителю суммы платежа за совершение
          нотариального действия в случае отказа в совершении нотариального
          действия
        </div>
        <StepRequisites
          :data="statement.storageIssueStep3"
          :statement-type="StatementType.STORAGE_ISSUE"
        />
      </v-col>
    </v-row>
    <v-row v-if="statement.locationStep">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Выбор места совершения нотариального действия
        </div>
        <div>
          <StepSign :data="statement.locationStep" />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { StatementType } from '@/types/services';
import Subject from "@/components/elements/statement/FullStatementView/elements/Subject";
import StepRequisites from '@/components/elements/statement/FullStatementView/steps/common/StepRequisites';
import StepSign from '@/components/elements/statement/FullStatementView/steps/common/StepSign';
import Step2 from '@/components/elements/statement/FullStatementView/steps/StorageIssue/Step2';

export default {
  name: 'StorageIssue',
  props: {
    statement: {
      type: Object,
      required: true,
    },
  },
  components: {
    Step2,
    StepRequisites,
    StepSign,
    Subject,
  },
  data: () => ({
    StatementType,
  }),
};
</script>

<style scoped></style>
